export default function OrderAttachments({order,onDownload}) {
  const frozen=order.attachment_membership==='frozen'||order.attachment_snapshot_version===1;
  const files=order.attachments||[];
  return <div className="overflow-hidden rounded-xl border">
    <div className="border-b bg-slate-50 px-4 py-3 text-xs text-slate-500">
      {frozen?'Files retained when this order was created':`Current source files from quote ${order.source_quote_reference||'-'}`}
      {!frozen&&<p className="mt-1">This older order uses the quote's current file list.</p>}
    </div>
    {files.map((file,index)=>{
      const unavailable=file.availability==='unavailable'||!file.id;
      return <button key={file.id||`${file.filename}-${index}`} disabled={unavailable}
        onClick={()=>onDownload(file)}
        className="flex w-full items-center justify-between border-b px-4 py-3 text-left text-sm hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60">
        <span><b>{file.filename}</b>
          {file.bytes>0&&<span className="ml-3 text-xs text-slate-500">{Math.ceil(file.bytes/1024)} KB</span>}
          {unavailable&&<span className="mt-1 block text-xs text-red-700">{file.error||'This file is unavailable.'}</span>}
        </span>
        <span className="ml-3 text-xs">{unavailable?'Unavailable':'Download'}</span>
      </button>;
    })}
    {!files.length&&<div className="p-8 text-center text-sm text-slate-500">
      {frozen?'No files were retained for this order.':'No source files are attached to this order.'}
    </div>}
  </div>;
}
